import React from 'react';
import { Redirect } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import './css/QuizHomeCSS.css';
import Banner_Page from './images/Banner_KosaKata_Winner.png';
import { Locale, Lang } from '../../Localization/CustomLocalization.js';
import winnersData from '../../data/quizWinners.json';

export default class QuizWinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { redirect: false, redirectLink: '' };
  }

  GotoPage = (path) => { this.setState({ redirect: true, redirectLink: path }); }

  capitalize = (text) => {
    if (!text) return '';
    return String(text).split(' ').map(part => {
      if (!part) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    }).join(' ');
  }

  renderArea = (areaName) => {
    const area = winnersData[areaName] || {};
    const standards = Object.keys(area);
    return (
      <div style={{ width: '100%', marginBottom: 15 }} key={areaName}>
        {standards.map((std) => (
          <div key={std} className='quiz-winner-standard-block'>
            <div className='quiz-winner-standard-header'>
              {std}
              <span className='badge badge-light' style={{ marginLeft: 8 }}>{Locale('label-top-10-listing', this.props.Locale || Lang.English)}</span>
            </div>
            <div className='quiz-winner-card' style={{ background: 'white', padding: 10, borderRadius: 6 }}>
              <table className='table table-sm table-hover table-striped quiz-winner-table' style={{ marginBottom: 0 }}>
                <thead>
                  <tr>
                    <th style={{ width: 25 }}>{Locale('label-ranking', this.props.Locale || Lang.English)}</th>
                    <th style={{ width: '40%' }}>{Locale('label-name', this.props.Locale || Lang.English)}</th>
                    <th style={{ width: '60%' }}>{Locale('label-school', this.props.Locale || Lang.English)}</th>
                  </tr>
                </thead>
                <tbody>
                  {(area[std] || []).map((item, idx) => (
                    <tr key={idx}>
                      <td style={{ verticalAlign: 'top', width: 60 }}>{item.rank}</td>
                      <td style={{ verticalAlign: 'top' }}>
                        <div style={{ fontWeight: 600 }}>{this.capitalize(item.name)}</div>
                      </td>
                      <td style={{ verticalAlign: 'top' }}>
                        <div style={{ fontWeight: 600 }}>{this.capitalize(item.school)}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    );
  }

  render = () => {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectLink} />;
    }

    return (
      <div style={{
        backgroundColor: 'transparent',
        minHeight: '100%',
        width: '100%',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        paddingTop: window.innerWidth < 576 ? 5 : 25,
      }}>
        <div className="container" style={{ maxWidth: '650px', backgroundColor: 'lavender', paddingTop: 15, paddingBottom: 15, borderRadius: 5 }}>
          <div className="row">
            <aside className="col-sm-12">
              <div className="card" style={{ backgroundColor: '#007bff' }}>
                <article className="card-body text-center">
                  <span style={{
                    color: 'white', fontSize: 25, textAlign: 'center', fontWeight: 'bold',
                    float: "left"
                  }}>{Locale('kosa-kota-prize-winner', this.props.Locale || Lang.English)}</span>
                </article>
              </div>
              <div className="card">
                <article className="card-body">
                  <div className='row'>
                    <div className='col'>
                      <img src={Banner_Page} alt={Locale('kosa-kota-prize-winner', this.props.Locale || Lang.English)} width={'100%'} />
                    </div>
                  </div>
                  <br />
                  <div className='row'>
                    <div className='col'>
                      <button type="button" className="btn btn-primary btn-block"
                        onClick={() => this.setState({ redirect: true, redirectLink: '/home' })}
                      >{Locale('back-to-home', this.props.Locale || Lang.English)}</button>
                    </div>
                  </div>
                </article>
              </div>
            </aside>

            <span id='pre-page-title'>&nbsp;</span>

            <aside className="col-sm-12">
              <div className="card">
                <article className="card-body">
                  <div style={{ marginTop: 15 }}>
                    <Tabs defaultActiveKey={Object.keys(winnersData)[0]} id="quiz-winner-tabs">
                      {Object.keys(winnersData).map((area) => (
                        <Tab eventKey={area} title={area} key={area}>
                          <div style={{ paddingTop: 10 }}>
                            {this.renderArea(area)}
                          </div>
                        </Tab>
                      ))}
                    </Tabs>
                  </div>
                </article>
              </div>
            </aside>
          </div>
        </div>

        <div style={{ height: '200px', width: '100%' }}>
          <span>&nbsp;</span>
        </div>
      </div>
    );
  }
}
